<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction"></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      border
    >
      <el-table-column
        :label="$t('Shop.Name')"
        width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          field(scope.row.ShopInfo.Name)
        }}</template>
      </el-table-column>
      <el-table-column label="当前余额" width="90">
        <template slot-scope="scope">
          <span class="text_red">${{ scope.row.ShopInfo.Balance }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag size="mini" :class="'st' + scope.row.Status" effect="plain">{{
            $t("ShopPayoutStatus")[scope.row.Status]
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提款金额" width="90">
        <template slot-scope="scope">
          <span class="text_powder">${{ scope.row.Amount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="银行名" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.BankName }}
        </template>
      </el-table-column>
      <el-table-column label="账号" width="150">
        <template slot-scope="scope">
          {{ scope.row.Account }}
        </template>
      </el-table-column>
      <el-table-column label="开户名" width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.AccountName }}
        </template>
      </el-table-column>
      <el-table-column label="提交时间" width="150">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.Created) }}
        </template>
      </el-table-column>
      <el-table-column label="审核时间" width="150">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.Modified) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operation')" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="small"
            v-if="scope.row.Status == 1"
            @click="Approve(scope.row.Id)"
            >审核通过</el-button
          >
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.Status == 1"
            @click="Refused(scope.row.Id)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "util/date";
import {
  getShopPayoutList,
  shopPayoutApprove,
  shopPayoutRefused,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    formatDateTime: function (val) {
      if (val == null) {
        return "";
      }
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;
      getShopPayoutList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    Approve(id) {
      this.$confirm("确定通过审核吗？", this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          shopPayoutApprove({ Id: id }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    Refused(id) {
      this.$confirm("确定驳回吗？", this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          shopPayoutRefused({ Id: id }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style scoped>
.st1 {
  color: orange !important;
  border-color: orange !important;
}

.st2 {
  color: limegreen !important;
  border-color: limegreen !important;
}

.st3 {
  color: dimgray !important;
  border-color: dimgray !important;
}

.st4 {
  color: tomato !important;
  border-color: tomato !important;
}
</style>
